import React from 'react';
import { useProfile } from '../../contexts/ProfileContext';
import { BRAND_GREEN, BRAND_GOLD } from '../../theme/sucronTheme';


/**
 * SuperModeToggle — Admin-only toggle between "full visibility" and "role-based view".
 *
 * When ON:  All nav sections visible (including Governance, Ingestion, Auditor, etc.)
 * When OFF: Admin sees the sidebar as the active role would, except Researcher/Recruiter
 *           remain visible (controlled by hasCapability, not superMode).
 */
const SuperModeToggle = () => {
  const { isSuperAdmin, superMode, toggleSuperMode } = useProfile();

  if (!isSuperAdmin) return null;

  return (
    <div className="px-3 py-2 border-b border-gray-100">
      <button
        onClick={() => toggleSuperMode()}
        className="w-full flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-gray-50 transition-all duration-200"
      >
        <span className="text-lg">{superMode ? '🔓' : '🔒'}</span>
        <div className="flex-1 text-left">
          <p
            className="text-[10px] font-bold uppercase tracking-wider"
            style={{ color: BRAND_GOLD }}
          >
            Super Admin
          </p>
          <p className="text-sm font-semibold" style={{ color: BRAND_GREEN }}>
            {superMode ? 'Visão Completa' : 'Visão por Perfil'}
          </p>
        </div>
        {/* Toggle switch */}
        <div
          className={`w-10 h-5 rounded-full transition-colors duration-200 relative flex-shrink-0 ${
            superMode ? 'bg-green-600' : 'bg-gray-300'
          }`}
        >
          <div
            className={`absolute top-0.5 w-4 h-4 rounded-full bg-white shadow transition-transform duration-200 ${
              superMode ? 'translate-x-5' : 'translate-x-0.5'
            }`}
          />
        </div>
      </button>
    </div>
  );
};

export default SuperModeToggle;
